import { render, staticRenderFns } from "./BulkImport.vue?vue&type=template&id=e28488e0"
import script from "./BulkImport.vue?vue&type=script&lang=js"
export * from "./BulkImport.vue?vue&type=script&lang=js"
import style0 from "./BulkImport.vue?vue&type=style&index=0&id=e28488e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports